import { api } from '../../../api/api';
import { SignalType } from './types';

const GET_SIGNAL = 'GET_SIGNAL';
export const checkerApi = api.enhanceEndpoints({ addTagTypes: [GET_SIGNAL] }).injectEndpoints({
  endpoints: (build) => ({
    getSignal: build.query<{ PostCode: string; Availability: SignalType[] }, { postCode: string }>({
      query: ({ postCode }) => ({
        method: 'GET',
        url: 'ofcom-signal/' + postCode
      }),
      providesTags: [GET_SIGNAL]
    })
  })
});

export const { useLazyGetSignalQuery } = checkerApi;
